import { render, staticRenderFns } from "./RadioFrequency.vue?vue&type=template&id=14febd71&scoped=true&lang=html&"
import script from "./RadioFrequency.vue?vue&type=script&lang=js&"
export * from "./RadioFrequency.vue?vue&type=script&lang=js&"
import style0 from "./RadioFrequency.vue?vue&type=style&index=0&id=14febd71&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14febd71",
  null
  
)

export default component.exports